/** Own ledger tabs gated behind /own-ledger/features email allowlist. */

export const HISTORY_LOCAL_TAB_ID = "history-local";
export const ANALYTICS_LOCAL_TAB_ID = "analytics-local";
export const PFOLIO_TAB_ID = "pfolio";

export const OWN_LEDGER_TAB_IDS = new Set([
  HISTORY_LOCAL_TAB_ID,
  ANALYTICS_LOCAL_TAB_ID,
  PFOLIO_TAB_ID,
]);

export type OwnLedgerReadSource = "stockforge" | "own_ledger";

export interface OwnLedgerFeatures {
  enabled: boolean;
  dualWrite: boolean;
  readSource: OwnLedgerReadSource;
  schemaVersion: number;
}

let cached: OwnLedgerFeatures | null = null;

const DEFAULT_FEATURES: OwnLedgerFeatures = {
  enabled: false,
  dualWrite: true,
  readSource: "stockforge",
  schemaVersion: 1,
};

export async function loadOwnLedgerFeatures(force = false): Promise<OwnLedgerFeatures> {
  if (!force && cached) return cached;
  try {
    const res = await fetch("/own-ledger/features", {
      method: "GET",
      credentials: "include",
      headers: { Accept: "application/json" },
    });
    if (!res.ok) {
      // Auth denials are stable; 5xx / network should retry next call.
      if (res.status === 401 || res.status === 403) {
        cached = DEFAULT_FEATURES;
        return cached;
      }
      return DEFAULT_FEATURES;
    }
    const payload = (await res.json()) as Partial<OwnLedgerFeatures>;
    cached = {
      enabled: Boolean(payload.enabled),
      dualWrite: payload.dualWrite !== false,
      readSource: payload.readSource === "own_ledger" ? "own_ledger" : "stockforge",
      schemaVersion: Number(payload.schemaVersion) || 1,
    };
    return cached;
  } catch {
    return DEFAULT_FEATURES;
  }
}

export function isOwnLedgerEnabled(): boolean {
  return cached?.enabled === true;
}

export function resetOwnLedgerFeatures(): void {
  cached = null;
}

export function filterOwnLedgerTabs<T extends { id: string }>(definitions: T[]): T[] {
  if (isOwnLedgerEnabled()) return definitions;
  return definitions.filter((tab) => !OWN_LEDGER_TAB_IDS.has(tab.id));
}
